import React from 'react'
import { HubEvaluatorInvites } from 'domain/feature/hub/evaluator/invites'

export const HubEvaluatorInvitesPage = (): JSX.Element => {
  return (
    <HubEvaluatorInvites />
  )
}
